// ===========================================================================
//  Reveals al hacer scroll (IntersectionObserver).
//  NOTA: la animación de los hexágonos anidados y la avispa la gobierna ahora
//  GSAP ScrollTrigger (assets/js/gsap-animations.js). Aquí solo quedan los
//  reveals simples y secuenciales del resto de la página.
// ===========================================================================
function setupIntersectionObservers() {
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.1
    };

    // Reveal simple: añade .in-view la primera vez que el elemento entra.
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
                obs.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const elementsToAnimate = document.querySelectorAll(
        '.image-collage, .wasp-hex-title, .wasp-hex-description, .uas-img-bg, .mission-title, .uas-block, .formacion-feature'
    );
    elementsToAnimate.forEach(element => {
        if (element) observer.observe(element);
    });

    // Reveal secuencial: escalona por orden de aparición.
    const sequentialObserver = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const delay = (entry.target.dataset.index || 0) * 150;
                setTimeout(() => {
                    entry.target.classList.add('in-view');
                }, delay);
                obs.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const sequentialElements = document.querySelectorAll('.mision-icon-block, .wasp-hex-label, .formacion-title, .formacion-text');
    sequentialElements.forEach((element, index) => {
        if (element) {
            element.dataset.index = index;
            sequentialObserver.observe(element);
        }
    });
}

// Inicialización única por página.
function initializeObservers() {
    if (window.observersInitialized) return;
    window.observersInitialized = true;

    setupIntersectionObservers();

    // Entrada escalonada de los items del ecosistema (columna izquierda).
    setTimeout(() => {
        const hexItems = document.querySelectorAll('.wasp-hex-item');
        hexItems.forEach((item, index) => {
            item.style.animationDelay = `${index * 0.15}s`;
            item.classList.add('animate-in');
        });
    }, 100);
}

if (document.readyState === 'complete') {
    requestAnimationFrame(initializeObservers);
} else {
    window.addEventListener('load', initializeObservers, { once: true });
}

// Soporte Turbo: reinicia en cada navegación.
document.addEventListener('turbo:load', () => {
    window.observersInitialized = false;
    requestAnimationFrame(initializeObservers);
});
